import Vue from 'vue'

export type FilterType =
  'Class' |
  'CustomerGroup' |
  'ProductCollection' |
  'Modality' |
  'Region' |
  'Product' |
  'Term' |
  'SalesChannel' |
  'StarValue' |
  'Stop' |
  'Zone'

export type PaymentMethod =
  'ideal' |
  'creditcard' |
  'mistercash' |
  'directebank' |
  'free' |
  'pin' |
  'cash'

export type ShopConfig = {
  includeClearAllFilterButton: boolean,
  salesChannelIds: Array<string>,
  overviewFilterTypes: Array<FilterType>,
  overviewRoute: string,
  paymentRoute: string,
  mixedShopError: Object,
  paymentMethods: Array<PaymentMethod>,
  type: string
}
export type Shop = {
  config: ShopConfig
}

export class NalShop implements Shop {
  config: ShopConfig

  constructor () {
    this.config = {
      salesChannelIds: [Vue.$container.config.productApiSalesChannelId || 'Warning: config key productApiSalesChannelId not set'],
      includeClearAllFilterButton: true,
      overviewFilterTypes: ['CustomerGroup', 'ProductCollection', 'Modality'],
      overviewRoute: 'ProductOverview',
      paymentRoute: 'Payment',
      mixedShopError: {message: 'mixed-shop-items-nal', link: 'AbtProductOverview'},
      paymentMethods: ['ideal', 'creditcard', 'mistercash', 'directebank', 'free', 'pin', 'cash'],
      type: 'NAL'
    }
  }
}

export class AbtShop implements Shop {
  config: ShopConfig

  constructor () {
    this.config = {
      salesChannelIds: [Vue.$container.config.productApiSalesChannelAbtId || 'Warning: config key productApiSalesChannelAbtId not set'],
      includeClearAllFilterButton: false,
      overviewFilterTypes: ['Region'],
      overviewRoute: 'AbtProductOverview',
      paymentRoute: 'AbtPayment',
      mixedShopError: {message: 'mixed-shop-items-flow', link: 'ProductOverview'},
      paymentMethods: ['ideal', 'free', 'pin', 'cash'],
      type: 'ABT'
    }
  }
}

export class SpecialSaleShop implements Shop {
  config: ShopConfig
  slug: string

  constructor (slug: string) {
    this.slug = slug
    this.config = {
      salesChannelIds: [Vue.$container.config.productApiSalesChannelSpecialId || 'Warning: config key productApiSalesChannelSpecialId not set'],
      includeClearAllFilterButton: true,
      overviewFilterTypes: ['CustomerGroups', 'ProductCollection', 'Modality'],
      overviewRoute: 'ProductOverview',
      paymentRoute: 'Payment',
      mixedShopError: {message: 'mixed-shop-items-nal', link: 'AbtProductOverview'},
      paymentMethods: ['ideal', 'creditcard', 'mistercash', 'directebank', 'free', 'pin', 'cash'],
      type: 'NAL'
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/shop/types.js